/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-nested-ternary */
import { useEffect, useState, Suspense } from 'react';

import {
  useNavigate, NavigateFunction, useSearchParams, useLocation,
  Navigate,
} from 'react-router-dom';
import {
  useDispatch, useSelector,
} from 'react-redux';
import { actions } from 'Slice/GlobalSearchResultsSlice';

import ArticlesSection from 'Components/globalSearch/components/ArticlesSection';
import InfiniteScroll from 'react-infinite-scroll-component';
import { usePrevious } from 'Utils/hooks/usePrevious';
import SocialCardSkeleton from 'Components/common/skeleton/SocialCardSkeleton';
import {
  articlesData, companiesData, peopleData, selectCompanyLoaded,
  selectLoading, selectPersonLoaded, selectSearchLoaded,
  selectPersonLoading, selectCompanyLoading, industriesData,
  selectSearchText, buyerGroupsData, selectBuyerGroupsLoading,
  documentData,
  selectGlobalSearchScreenName,
} from 'Selector/GlobalSearchResultsSelector';

import SearchCompanySkeletonBlock from 'Components/common/skeleton/SearchCompanySkeletonBlock';
import AccountPopOver from 'Components/common/components/AccountPopOver';
import SearchIndustrySkeletonBlock from 'Components/common/skeleton/SearchIndustrySkeletonBlock';
import IndustriesSection from 'Components/globalSearch/components/IndustriesSectionGlobalSearch';
import SearchNoResultFoundWidget from 'Components/common/components/SearchNoResultFoundWidget';

import { selectScreenName, selectShowGlobalGilroy } from 'Selector/GlobalSearchContentSelector';
import DrawerPeopleGroup from 'Components/people/components/DrawerPeopleGroup';
import { actions as groupActions } from 'Slice/GroupsSlice';
import {
  COMPANY_NEWS_ROUTE, FEED_GILROY_ROUTE, ONBOARDING, PERSONALITY_INSIGHTS_ROUTE,
  SALESFORCE_COMPANY_SEARCH_ROUTE,
  SALESFORCE_PERSON_SEARCH_ROUTE,
} from 'Utils/Constants';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import { selectData } from 'Selector/CertificationSelector';
import {
  ArticleSlicerResultPage,
  GroupSlicerResultPage, IsTablet, SlicerResultPage, getLangCookie, isSalesforce,
} from 'Utils/UtilityFunctions';
import BuyerGroupsSection from 'Components/common/components/BuyerGroupsSection';

import SearchBuyerGroupSkeletonBlock from 'Components/common/skeleton/SearchBuyerGroupSkeltonBlock';
import SubNavBarPrimary from 'Components/layout/headers/SubNavBarPrimary';
import ViewTabs from 'Components/common/tabs/ViewTabs';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import classNames from 'classnames';
import styled from 'styled-components';
import { actions as UiAction } from 'Slice/UISlice';
import { ViewInterface } from 'Types/GlobalTypes';
import { selectViewTab } from 'Selector/UISelector';
import {
  extendedSearchLoader,
  maxTablet,
  primaryColor,
  primaryFont,
  primaryHeadingColor,
  secondaryFont,
  smMobile,
  wMBold,
} from 'Utils/utilsStyle';
import PeopleSectionListView from 'Components/common/components/PeopleSectionListView';
import CompaniesSectionListView from 'Components/common/components/CompaniesSectionListView';
import BuyerGroupsSectionListView from 'Components/common/components/BuyerGroupsSectionListView';
import ArticlesSectionListView from 'Components/globalSearch/components/ArticlesSectionListView';
import DocumentHub from 'Pages/document/DocumentHub';
import DocumentHubListView from 'Pages/document/DocumentHubListView';
import IndustriesSectionListView from 'Components/globalSearch/components/IndustriesSectionListView';
import { Gilroy } from 'gilroy-global';
import { useGilroy } from 'Utils/hooks/useGilroy';
import ExtendedSearchLoader from 'Components/common/components/ExtendedSearchLoader';
import SearchPersonSkeletonBlock from '../../Components/common/skeleton/SearchPersonSkeletonBlock';
import {
  SearchResultsRequest,
} from '../../Types/GlobalSearchResultsTypes';

import BackIcon from '../../Components/common/assets/svgIcons/BackIcon';
import DrawerAlerts from '../../Components/alerts/components/DrawerAlerts';
import NavBarPrimary, { chatActions, chatStates } from '../../Components/layout/headers/NavBarPrimary';
import GlobalSearch from '../../Components/globalSearch/components/GlobalSearch';
import CompaniesSection from '../../Components/common/components/CompaniesSection';
import PeopleSection from '../../Components/common/components/PeopleSection';

export type SearchResultsRouteState = {
  enableBackButton?: boolean
  hideBackIcon?: boolean
  query: string
  previousPath?: string
};
type Props = {
  hideNavbar?: boolean,
  hideArticles?: boolean,
  forceSearch?: boolean,
  onboardingSearchFlag?: boolean,
  hideIndustries?: boolean
} & typeof defaultProps;

const defaultProps = {
  hideNavbar: false,
  hideArticles: false,
  forceSearch: false,
  onboardingSearchFlag: false,
  hideIndustries: false,
};

const Wrapper = styled.div`
.boxDoor{
  z-index: 3;
}
.container {
  margin-bottom: 100px;
  @media all and (max-width: ${maxTablet}) {
    margin-bottom: 0px;
  }
}
.person-item {
  margin-bottom: 0px;
}
.small-button-chinese{
  margin-bottom: 0px;
}
.M-companies .companies-margin {
  .ant-row {
    &.Grid-width-row {
      &.col-six-fix-md {
        margin-top: 0px;
      }
    } 
  }
}
.company-image-parent {
  @media all and (max-width: ${smMobile}) {
    margin-bottom: 4px;
  }
}
`;

const LoaderWrapper = styled.div`
  width: 100%;
  .main {
    background:white;
    border:1px solid ${primaryColor};
    padding: 5px 10px;
    text-align: center;
    border-radius: 10px;
    display: flex;
    align-items: center;
    width: 100%;
    margin: 0px;
    .loader-style{
      height: 30px;
      width: 30px;
      margin-right: 10px;
    }
    .text{
      font-size: 16px;
      color:${primaryHeadingColor};
      font-weight: ${wMBold};
      font-family: ${secondaryFont};
      letter-spacing: -0.45px;
      line-height: 14px;
      margin-bottom: 0px;
    }
  }
`;

const NoPersonFound = styled.span`
  padding: 20px;
  min-height: 250px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 16px;
  color: rgb(126, 126, 126);
  font-family: ${primaryFont};
`;
const Search = function Search({
  hideNavbar,
  hideArticles,
  forceSearch,
  onboardingSearchFlag,
  hideIndustries,
}: Props) {
  const dispatch = useDispatch();
  const { gilroyStates, gilroyActions } = useGilroy();
  const { saveUrl: savedUrlV2 } = chatStates;
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [dragging, setDragging] = useState(false);
  const [top, setTop] = useState(0);
  const loading: boolean = useSelector(selectLoading);
  const peopleCollection = useSelector(peopleData);
  const documentCollection = useSelector(documentData);
  const companiesCollection = useSelector(companiesData);
  const buyerGroupsCollection = useSelector(buyerGroupsData);
  const articlesCollection = useSelector(articlesData);
  const industriesCollection = useSelector(industriesData);
  const personsLoaded = useSelector(selectPersonLoaded);
  const companiesLoaded = useSelector(selectCompanyLoaded);
  const personsLoading: boolean = useSelector(selectPersonLoading) ?? false;
  const companiesLoading: boolean = useSelector(selectCompanyLoading) ?? false;
  const buyerGroupsLoading: boolean = useSelector(selectBuyerGroupsLoading) ?? false;
  const globalSearchLoaded = useSelector(selectSearchLoaded);
  const screenName = useSelector(selectScreenName);
  const searchText = useSelector(selectSearchText);
  const showGlobalGilroy = useSelector(selectShowGlobalGilroy);
  const currentUrl = window.location.href;
  const slicerNumber: number = SlicerResultPage();
  const slicerGroupNumber: number = GroupSlicerResultPage();
  const slicerArticleNumber: number = ArticleSlicerResultPage();
  const tabView: ViewInterface = useSelector(selectViewTab);
  const isListView = tabView.view === 'listView';
  const location = useLocation();
  const { state } = location;
  const enableBackButton: boolean = (state as SearchResultsRouteState)?.enableBackButton ?? false;
  const [searchParams] = useSearchParams();
  const previousPath = (state as SearchResultsRouteState)?.previousPath ?? FEED_GILROY_ROUTE;

  const navigate: NavigateFunction = useNavigate();
  const query = searchParams.get('query') ?? '';

  const extendedSections = ['person', 'company', 'article', 'industry', 'group', 'document'];
  const extendedSection = (searchParams.get('extend') ?? '');
  const prevExtendedSection = usePrevious(extendedSection);
  const isDetailedSearch: boolean = extendedSections.includes(extendedSection);

  const [personPage, setPersonPage] = useState(1);
  const [companyPage, setCompanyPage] = useState(1);
  const [buyerGroupPage, setBuyerGroupPage] = useState(1);
  const [atriclePage, setAtriclePage] = useState(1);
  const [industryPage, setIndustryPage] = useState(1);
  const [documentpage, setDocumentPage] = useState(1);
  const [activeTab, setActiveTab] = useState('');

  const queryString = searchParams.get('query') || '';
  const groupId = searchParams.get('groupId') || '';
  const groupIdParsed = groupId ? parseInt(groupId, 10) : 0;
  const globalScreenName = useSelector(selectGlobalSearchScreenName);

  if (isSalesforce()) {
    if (extendedSection === 'person') {
      return <Navigate to={`${SALESFORCE_PERSON_SEARCH_ROUTE}${query}`} state={{ from: 'salesforce-search' }} replace />;
    }
    return <Navigate to={`${SALESFORCE_COMPANY_SEARCH_ROUTE}${query}`} state={{ from: 'salesforce-search' }} replace />;
  }

  const fetchMorePeople = () => {
    if (!loading) {
      setPersonPage(personPage + 1);
      const obj: SearchResultsRequest = {
        query: isDetailedSearch ? `${extendedSection}:${queryString}` : queryString,
        screenName,
        page: personPage + 1,
        defaultLanguage: getLangCookie(),
      };
      dispatch(actions.globalSearchResults(obj));
    }
  };
  const fetchMoreCompanies = () => {
    if (!loading) {
      setCompanyPage(companyPage + 1);
      const obj: SearchResultsRequest = {
        query: isDetailedSearch ? `${extendedSection}:${queryString}` : queryString,
        screenName,
        page: companyPage + 1,
        defaultLanguage: getLangCookie(),
      };
      dispatch(actions.globalSearchResults(obj));
    }
  };

  const fetchMoreBuyerGroups = () => {
    if (!loading) {
      setBuyerGroupPage(buyerGroupPage + 1);
      const obj: SearchResultsRequest = {
        query: isDetailedSearch ? `${extendedSection}:${queryString}` : queryString,
        screenName,
        page: buyerGroupPage + 1,
        defaultLanguage: getLangCookie(),
      };
      dispatch(actions.globalSearchResults(obj));
    }
  };

  const fetchMoreArticles = () => {
    if (!loading) {
      setAtriclePage(atriclePage + 1);
      const obj: SearchResultsRequest = {
        query: isDetailedSearch ? `${extendedSection}:${queryString}` : queryString,
        screenName,
        page: atriclePage + 1,
        ...(isDetailedSearch && extendedSection === 'article' && { type: 'News' }),
        defaultLanguage: getLangCookie(),
      };
      dispatch(actions.globalSearchResults(obj));
    }
  };

  const fetchMoreIndustries = () => {
    if (!loading) {
      setIndustryPage(industryPage + 1);
      const obj: SearchResultsRequest = {
        query: isDetailedSearch ? `${extendedSection}:${queryString}` : queryString,
        screenName,
        page: industryPage + 1,
        defaultLanguage: getLangCookie(),
      };
      dispatch(actions.globalSearchResults(obj));
    }
  };

  const fetMoreDocuments = () => {
    if (!loading) {
      setDocumentPage(documentpage + 1);
      const obj: SearchResultsRequest = {
        query: isDetailedSearch ? `${extendedSection}:${queryString}` : queryString,
        screenName,
        page: documentpage + 1,
        defaultLanguage: getLangCookie(),
      };
      dispatch(actions.globalSearchResults(obj));
    }
  };

  useEffect(() => {
    if (globalScreenName === 'addCompanyToServiceLine') {
      dispatch(actions.globalSearchResultsResetEmpty());
      const obj: SearchResultsRequest = {
        query: queryString,
        // query: isDetailedSearch ? `${extendedSection}:${queryString}` : queryString,
        screenName,
        ...(groupIdParsed && groupIdParsed > 0 && { group_id: groupIdParsed }),
        ...(isDetailedSearch && !isSalesforce() && { page: 1 }),
        // ...(isDetailedSearch && extendedSection === 'article' && { type: 'News' }),
        defaultLanguage: getLangCookie(),
      };
      setPersonPage(1);
      setCompanyPage(1);
      setAtriclePage(1);
      setIndustryPage(1);
      setBuyerGroupPage(1);
      setDocumentPage(1);
      dispatch(actions.globalSearchResults(obj));
      window.scrollTo(0, 0);
      return;
    }
    if (searchText.split(':').pop() !== queryString) {
      dispatch(actions.globalSearchResultsResetEmpty());
      const obj: SearchResultsRequest = {
        query: queryString,
        // query: isDetailedSearch ? `${extendedSection}:${queryString}` : queryString,
        screenName,
        ...(groupIdParsed && groupIdParsed > 0 && { group_id: groupIdParsed }),
        ...(isDetailedSearch && !isSalesforce() && { page: 1 }),
        // ...(isDetailedSearch && extendedSection === 'article' && { type: 'News' }),
        defaultLanguage: getLangCookie(),
      };
      setPersonPage(1);
      setCompanyPage(1);
      setAtriclePage(1);
      setIndustryPage(1);
      setBuyerGroupPage(1);
      setDocumentPage(1);
      dispatch(actions.globalSearchResults(obj));
      window.scrollTo(0, 0);
    }
  }, [query, forceSearch, groupId]);
  useEffect(() => {
    if (!globalSearchLoaded && searchText.split(':').pop() !== queryString) {
      window.scrollTo(0, 0);
    }
    if (savedUrlV2 !== currentUrl) {
      dispatch(UiAction.isShowGilroyGlobalToggle(false));
      chatActions.setShowLibrary(true);
      chatActions.setShowExamplePrompts(false);
      chatActions.resetChatHistory();
      chatActions.setSelectedConversationId(-1);
      chatActions.setHistoryPanelOpened(false);
    } else {
      chatActions.setSaveUrl('');
      chatActions.setSaveProfileName('');
    }
    return () => {
      setPersonPage(1);
      setCompanyPage(1);
      setAtriclePage(1);
      setIndustryPage(1);
      setBuyerGroupPage(1);
      dispatch(actions.globalSearchResultsReset());
    };
  }, []);

  // For extended people search (`extend=person`), keep the People section visible
  // as soon as the content search has completed, even if the extended search
  // is still loading. This ensures content-search results render immediately
  // with an extended-search loader, instead of the section disappearing until
  // `personsLoaded` becomes true.
  const isPeopleEmpty = (isDetailedSearch && extendedSection === 'person')
    ? (globalSearchLoaded || personsLoaded)
    : globalSearchLoaded;
  const isCompaniesEmpty = ((companiesCollection?.companies?.length ?? 0) > 0)
    && globalSearchLoaded;
  const isBuyerGroupsEmpty = ((buyerGroupsCollection?.groups?.length ?? 0) > 0)
    && globalSearchLoaded;
  const isArticlesEmpty = ((articlesCollection?.articles?.length ?? 0) > 0) && globalSearchLoaded;
  const isIndustriesEmpty = ((industriesCollection?.industries?.length ?? 0) > 0)
    && globalSearchLoaded;

  const isDocumentEmpty = ((documentCollection?.documents?.length ?? 0) > 0)
    && globalSearchLoaded;

  let isPeopleSectionVisible = loading ? true : isPeopleEmpty;
  let isCompaniesSectionVisible = loading ? true : isCompaniesEmpty;
  let isBuyerGroupsSectionVisible = loading ? true : isBuyerGroupsEmpty;
  let isArticlesSectionVisible = loading ? true : isArticlesEmpty;
  let isIndustriesSectionVisible = loading ? true : isIndustriesEmpty;
  let isDocumethubSectionVisible = loading ? true : isDocumentEmpty;
  const { pathname } = useLocation();

  if (extendedSection === 'person') {
    isCompaniesSectionVisible = false;
    isArticlesSectionVisible = false;
    isIndustriesSectionVisible = false;
    isBuyerGroupsSectionVisible = false;
    isDocumethubSectionVisible = false;
  } else if (extendedSection === 'company') {
    isPeopleSectionVisible = false;
    isArticlesSectionVisible = false;
    isIndustriesSectionVisible = false;
    isBuyerGroupsSectionVisible = false;
    isDocumethubSectionVisible = false;
  } else if (extendedSection === 'group') {
    isPeopleSectionVisible = false;
    isCompaniesSectionVisible = false;
    isArticlesSectionVisible = false;
    isIndustriesSectionVisible = false;
    isDocumethubSectionVisible = false;
  } else if (extendedSection === 'article') {
    isCompaniesSectionVisible = false;
    isPeopleSectionVisible = false;
    isIndustriesSectionVisible = false;
    isBuyerGroupsSectionVisible = false;
    isDocumethubSectionVisible = false;
  } else if (extendedSection === 'industry') {
    isCompaniesSectionVisible = false;
    isArticlesSectionVisible = false;
    isPeopleSectionVisible = false;
    isBuyerGroupsSectionVisible = false;
    isDocumethubSectionVisible = false;
  } else if (extendedSection === 'document') {
    isCompaniesSectionVisible = false;
    isArticlesSectionVisible = false;
    isPeopleSectionVisible = false;
    isBuyerGroupsSectionVisible = false;
    isIndustriesSectionVisible = false;
  }
  const personsToDisplay = isDetailedSearch ? peopleCollection?.persons
    : peopleCollection?.persons?.slice(0, slicerNumber);
  const personsToDisplayListView = isDetailedSearch ? peopleCollection?.persons
    : peopleCollection?.persons?.slice(0, 4);
  const companiesToDisplay = isDetailedSearch ? companiesCollection?.companies
    : companiesCollection?.companies?.slice(0, slicerNumber);
  const companiesToDisplayListView = isDetailedSearch ? companiesCollection?.companies
    : companiesCollection?.companies?.slice(0, 4);
  const articlesToDisplay = isDetailedSearch ? articlesCollection?.articles
    : articlesCollection?.articles?.slice(0, slicerArticleNumber);
  const articlesToDisplayListView = isDetailedSearch ? articlesCollection?.articles
    : articlesCollection?.articles?.slice(0, 2);
  const industriesToDisplay = isDetailedSearch ? industriesCollection?.industries
    : industriesCollection?.industries?.slice(0, slicerNumber);
  const industriesToDisplayListView = isDetailedSearch ? industriesCollection?.industries
    : industriesCollection?.industries?.slice(0, 2);
  const buyerGroupsToDisplay = isDetailedSearch ? buyerGroupsCollection?.groups
    : buyerGroupsCollection?.groups?.slice(0, slicerGroupNumber);
  const buyerGroupsToDisplayListView = isDetailedSearch ? buyerGroupsCollection?.groups
    : buyerGroupsCollection?.groups?.slice(0, 2);
  const documentsToDisplay = isDetailedSearch ? documentCollection?.documents
    : documentCollection?.documents?.slice(0, 4);
  const documentsToDisplayListView = isDetailedSearch ? documentCollection?.documents
    : documentCollection?.documents?.slice(0, 2);

  // Distinguish between the very first load (no people yet) and subsequent
  // pagination loads. On pagination we want to keep existing results visible
  // and only show bottom loaders instead of replacing the list with skeletons.
  const isInitialPeopleLoading = !globalSearchLoaded
    && ((personsToDisplay?.length ?? 0) === 0);

  const showInlineLoaderForPeople = (personsToDisplay?.length ?? 0) < 5
    && (loading || personsLoading);
  const showInlineLoaderForCompanies = (companiesToDisplay?.length ?? 0) < 5
    && (loading || companiesLoading);
  const showInlineLoaderForBuyerGroups = (buyerGroupsToDisplay?.length ?? 0) < 4
    && (loading || buyerGroupsLoading);
  const showInlineLoaderForIndustries = (industriesToDisplay?.length ?? 0) < 5
    && (loading);

  const isAllDataEmpty = () => globalSearchLoaded
    && companiesLoaded
    && personsLoaded
    && peopleCollection?.persons?.length === 0
    && companiesCollection?.companies?.length === 0
    && articlesCollection?.count === 0
    && industriesCollection?.industries?.length === 0
    && buyerGroupsCollection.groups?.length === 0
    && documentCollection?.documents?.length === 0;

  const isPersonDataEmpty = () => globalSearchLoaded
    && personsLoaded
    && peopleCollection?.persons?.length === 0;

  const isCompanyDataEmpty = () => globalSearchLoaded
    && companiesLoaded
    && companiesCollection?.companies?.length === 0;

  const isExtendedDataEmpty = () => {
    if ((extendedSection === 'person' && isPersonDataEmpty()) || (extendedSection === 'company' && isCompanyDataEmpty())) {
      return true;
    }
    if (extendedSection === 'company' && isCompanyDataEmpty()) {
      return true;
    }

    return false;
  };

  const isEmptyDataForOnBoarding = () => globalSearchLoaded
    && companiesLoaded
    && personsLoaded
    && peopleCollection?.persons?.length === 0
    && companiesCollection?.companies?.length === 0;

  const toggle = (flag: boolean) => {
    setOpenCreateModal(flag);
  };

  const isDrag = (a: boolean) => {
    if (a) dispatch(groupActions.setDropComplete(false));
    setDragging(a);
  };

  useEffect(() => {
    setShowNew(false);
    setOpenCreateModal(dragging);
  }, [dragging]);

  useEffect(() => {
    setActiveTab(extendedSection);
  }, [extendedSection]);

  const data = useSelector(selectData);

  useEffect(() => {
    if (peopleCollection.persons && peopleCollection.persons?.length > 0) {
      dispatch(certificationActions.certificationAction({
        type: 'person_search',
        source: 'search',
        data,
      }));
    }
    if (companiesCollection.companies && companiesCollection.companies?.length > 0) {
      dispatch(certificationActions.certificationAction({
        type: 'company_search',
        source: 'search',
        data,
      }));
    }
  }, [peopleCollection, companiesCollection]);

  useEffect(() => {
    if (isSalesforce()) {
      switch (extendedSection) {
        case 'company':
          if (companiesToDisplay?.length === 1) {
            const [company] = companiesToDisplay;
            navigate(`${COMPANY_NEWS_ROUTE}${company.companyId}`, { replace: true });
          }
          break;
        case 'person':
          if (personsToDisplay?.length === 1) {
            const [person] = personsToDisplay;
            navigate(`${PERSONALITY_INSIGHTS_ROUTE}${person.personId}&personType=${person.personType || 'EXECUTIVE'}`, { replace: true });
          }
          break;
        default:
      }
    }
  }, [companiesToDisplay, personsToDisplay]);

  useEffect(() => {
    if ((prevExtendedSection === 'company'
      || prevExtendedSection === 'group'
      || prevExtendedSection === 'industry'
      || prevExtendedSection === 'article') && extendedSection === '') {
      setTimeout(() => {
        window.scrollTo({
          top: top - 120,
          left: 0,
          behavior: 'smooth',
        });
      }, 200);
    }
  }, [extendedSection]);

  const setTopCoordinates = (type: string) => {
    let className = '';
    if (type === 'company') {
      className = 'M-Companies';
    } else if (type === 'group') {
      className = 'M-Buyer';
    } else if (type === 'industry') {
      className = 'M-Industries';
    } else if (type === 'article') {
      className = 'M-Articles';
    }
    const offsets = document.getElementsByClassName(className)[0]?.getBoundingClientRect();
    setTop(offsets.top);
  };

  const createRoute = (param: string) => {
    window.scrollTo(0, 0);
    const path = `${pathname}?query=${query}&extend=${param}`;
    return navigate(path, { state: { enableBackButton: true, previousPath } });
  };
  return (
    <Wrapper>
      {
        hideNavbar ? null : (
          <>
            <NavBarPrimary headerClassName="box-shadow no-overflow-on-header">
              <div className="left-side-wrap">
                {enableBackButton && (
                  <BackIcon onClick={() => {
                    const path = isDetailedSearch ? `${pathname}?query=${query}`
                      : previousPath;
                    navigate(path, {
                      state: isDetailedSearch ? { enableBackButton: true, previousPath }
                        : { previousPath },
                    });
                  }}
                  />
                )}
                <h1 className="heading">Results</h1>
              </div>
              <div className="right-side-wrap">
                <GlobalSearch iconMode={IsTablet()} />
                <DrawerAlerts />
                <AccountPopOver />
              </div>
            </NavBarPrimary>
            <SubNavBarPrimary>
              <div className="heading-inner-page tabs-placeholder wrap-slider hidden-scroll">
                <div className="head-wrap" />
                <div className="tips-placeholder ml-0">
                  {loading && !extendedSection ? (
                    <div className="tabs-wrapper">
                      {[1, 2, 3, 4, 5].map(() => (
                        <SkeletonCustom height="30px" width="110px" margin="0px 10px 0px 0px" marginSm="0px 10px 0px 0px" />
                      ))}
                    </div>
                  )
                    : (
                      <div className="tabs-wrapper">
                        {isSalesforce() && isDetailedSearch ? (
                          <>
                            {peopleCollection?.count > 0 && extendedSection === 'person' ? (
                              <span
                                className={classNames('tabs-item', { active: (activeTab === 'person') })}
                                onClick={() => createRoute('person')}
                                onKeyDown={() => createRoute('person')}
                                role="button"
                                tabIndex={0}
                              >
                                People
                              </span>
                            ) : null}

                            {companiesCollection?.count > 0 && extendedSection === 'company'
                              ? (
                                <span
                                  className={classNames('tabs-item', { active: (activeTab === 'company') })}
                                  onClick={() => createRoute('company')}
                                  onKeyDown={() => createRoute('company')}
                                  role="button"
                                  tabIndex={0}
                                >
                                  Companies
                                </span>
                              ) : null}
                          </>
                        ) : (
                          <>
                            {peopleCollection?.count > 0 ? (
                              <span
                                className={classNames('tabs-item', { active: (activeTab === 'person') })}
                                onClick={() => createRoute('person')}
                                onKeyDown={() => createRoute('person')}
                                role="button"
                                tabIndex={0}
                              >
                                People
                              </span>
                            ) : null}

                            {companiesCollection?.count > 0
                              ? (
                                <span
                                  className={classNames('tabs-item', { active: (activeTab === 'company') })}
                                  onClick={() => createRoute('company')}
                                  onKeyDown={() => createRoute('company')}
                                  role="button"
                                  tabIndex={0}
                                >
                                  Companies
                                </span>
                              ) : null}

                            {buyerGroupsCollection?.count > 0 ? (
                              <span
                                className={classNames('tabs-item', { active: (activeTab === 'group') })}
                                onClick={() => createRoute('group')}
                                onKeyDown={() => createRoute('group')}
                                role="button"
                                tabIndex={0}
                              >
                                BRM
                              </span>
                            ) : null}

                            {documentCollection.count > 0
                              ? (
                                <span
                                  className={classNames('tabs-item', { active: (activeTab === 'document') })}
                                  onClick={() => createRoute('document')}
                                  onKeyDown={() => createRoute('document')}
                                  role="button"
                                  tabIndex={0}
                                >
                                  Doc Hub
                                </span>
                              ) : null}

                            {industriesCollection?.count > 0 && !hideIndustries
                              ? (
                                <span
                                  className={classNames('tabs-item', { active: (activeTab === 'industry') })}
                                  onClick={() => createRoute('industry')}
                                  onKeyDown={() => createRoute('industry')}
                                  role="button"
                                  tabIndex={0}
                                >
                                  Industries
                                </span>
                              ) : null}

                            {articlesCollection?.count > 0 && !hideArticles
                              ? (
                                <span
                                  className={classNames('tabs-item', { active: (activeTab === 'article') })}
                                  onClick={() => createRoute('article')}
                                  onKeyDown={() => createRoute('article')}
                                  role="button"
                                  tabIndex={0}
                                >
                                  Articles
                                </span>
                              ) : null}
                          </>
                        )}
                      </div>
                    )}

                </div>
                <div className="right-side-sub-header">
                  <div className={classNames('view-tabs', {
                    notdisabledTabs: true,
                  })}
                  >
                    <ViewTabs
                      disabled={false}
                      listView={isListView}
                    />
                  </div>
                </div>
              </div>
            </SubNavBarPrimary>
          </>
        )
      }
      <div className="container placement-logic">
        <div className={classNames('styleing-wrapper', { fancyBox: !window.location.pathname?.includes(`/${ONBOARDING}`) || !isSalesforce() })}>
          {
            window.location.pathname?.includes(`/${ONBOARDING}`) ? (
              <>
                {isCompaniesSectionVisible ? (
                  <InfiniteScroll
                    hasMore={isDetailedSearch}
                    dataLength={companiesCollection?.companies?.length ?? 0}
                    next={fetchMoreCompanies}
                    loader={false && <SearchCompanySkeletonBlock sliceFlag={!isDetailedSearch} />}
                    className="o-x-hidden spacer"
                  >
                    <CompaniesSection
                      heading={companiesCollection?.title}
                      hideDefaultBackground
                      companiesCollection={companiesToDisplay}
                      loading={!companiesLoaded}
                      companyCount={companiesCollection.companies}
                      count={companiesCollection.count}
                      query={query?.replace(/&/g, '%26')}
                      showLoaderForLessResults={showInlineLoaderForCompanies}
                      {...(showInlineLoaderForCompanies
                        && {
                        numberOfLoaderForLessResults:
                          10 - (companiesToDisplay?.length ?? 0),
                      })}
                      disableNavigation
                    />
                  </InfiniteScroll>
                ) : <> </>}
                {isPeopleSectionVisible ? (
                  <InfiniteScroll
                    hasMore={isDetailedSearch}
                    dataLength={peopleCollection?.persons?.length ?? 0}
                    next={fetchMorePeople}
                    loader={false && <SearchPersonSkeletonBlock sliceFlag={!isDetailedSearch} />}
                    className="o-x-hidden spacer"
                  >
                    <PeopleSection
                      heading={peopleCollection?.title}
                      hideDefaultBackground
                      peopleCollection={personsToDisplay}
                      loading={isDetailedSearch ? !personsLoaded : !globalSearchLoaded}
                      peopleCount={peopleCollection.persons}
                      count={peopleCollection.count}
                      query={query?.replace(/&/g, '%26')}
                      showLoaderForLessResults={showInlineLoaderForPeople}
                      {...(showInlineLoaderForPeople
                        && { numberOfLoaderForLessResults: 10 - (personsToDisplay?.length ?? 0) })}
                      invertFollow
                      inGlobalSearch
                      bothSearchLoading={!personsLoaded || !globalSearchLoaded}
                    />
                  </InfiniteScroll>
                ) : <> </>}

              </>
            ) : (
              <>
                {isSalesforce() ? '' : (
                  <DrawerPeopleGroup
                    openNewCreate={openCreateModal}
                    setOpenNew={toggle}
                    showNew={showNew}
                    toggleShowNew={(bool: boolean) => setShowNew(bool)}
                    noButton
                    drag={dragging}
                  />
                )}
                {isPeopleSectionVisible && isListView ? (
                  <InfiniteScroll
                    hasMore={isDetailedSearch}
                    dataLength={peopleCollection?.persons?.length ?? 0}
                    next={fetchMorePeople}
                    loader={false && <SearchPersonSkeletonBlock sliceFlag={!isDetailedSearch} />}
                    className={classNames('o-x-hidden spacer', { 'o-y-hidden': !isDetailedSearch })}
                  >
                    <PeopleSectionListView
                      heading={peopleCollection?.title}
                      peopleCollection={personsToDisplayListView}
                      loading={isInitialPeopleLoading}
                      peopleCount={peopleCollection?.persons}
                      count={peopleCollection.count}
                      {...(showInlineLoaderForPeople
                        && { numberOfLoaderForLessResults: 10 - (personsToDisplay?.length ?? 0) })}
                      invertFollow
                      inGlobalSearch
                      query={query?.replace(/&/g, '%26')}
                    />
                  </InfiniteScroll>
                ) : <></>}
                {!peopleCollection.persons?.length && personsLoaded && globalSearchLoaded && !extendedSection
                  && !isAllDataEmpty() && !isExtendedDataEmpty() ? (
                  <NoPersonFound>No Person found</NoPersonFound>
                ) : <> </>}
                {isPeopleSectionVisible && !isListView ? (
                  <InfiniteScroll
                    hasMore={isDetailedSearch}
                    dataLength={peopleCollection?.persons?.length ?? 0}
                    next={fetchMorePeople}
                    loader={false && <SearchPersonSkeletonBlock sliceFlag={!isDetailedSearch} />}
                    className={classNames('o-x-hidden M-People', {
                      detailPage: isDetailedSearch,
                      hideArea: peopleCollection.count === 0,
                    })}
                  >
                    <PeopleSection
                      heading={peopleCollection?.title}
                      hideDefaultBackground
                      peopleCollection={personsToDisplay}
                      loading={isInitialPeopleLoading}
                      peopleCount={peopleCollection.persons}
                      count={peopleCollection.count}
                      query={query?.replace(/&/g, '%26')}
                      inGlobalSearch
                      showLoaderForLessResults={showInlineLoaderForPeople}
                      {...(showInlineLoaderForPeople
                        && { numberOfLoaderForLessResults: 10 - (personsToDisplay?.length ?? 0) })}
                      invertFollow
                      bothSearchLoading={!personsLoaded || !globalSearchLoaded}
                      isDrag={isDrag}
                    />
                  </InfiniteScroll>
                ) : (
                  ((personsLoading || !personsLoaded) && isSalesforce()) && (
                    isListView
                      ? (
                        <LoaderWrapper className="loader-wrapper">
                          <div className="main">
                            <img className="loader-style" src={extendedSearchLoader} alt="extended-loader" />
                            <p className="text">
                              {'Uncovering more People using xiQ\'s extended Search.'}
                            </p>
                          </div>
                        </LoaderWrapper>
                      )
                      : <ExtendedSearchLoader />
                  )
                )}
                {isCompaniesSectionVisible && isListView ? (
                  <InfiniteScroll
                    hasMore={isDetailedSearch}
                    dataLength={companiesCollection?.companies?.length ?? 0}
                    next={fetchMoreCompanies}
                    loader={false && <SearchCompanySkeletonBlock sliceFlag={!isDetailedSearch} />}
                    className={classNames(
                      'o-x-hidden  M-Companies spacer',
                      { detailPage: isDetailedSearch },
                      { 'o-y-hidden': !isDetailedSearch },
                    )}
                  >
                    <CompaniesSectionListView
                      heading={companiesCollection?.title}
                      companiesCollection={companiesToDisplayListView}
                      loading={!globalSearchLoaded}
                      companyCount={companiesCollection.companies}
                      count={companiesCollection.count}
                      listView={isListView}
                      inGlobalSearch
                      query={query?.replace(/&/g, '%26')}
                    />
                  </InfiniteScroll>
                ) : <> </>}
                {isCompaniesSectionVisible && !isListView ? (
                  <InfiniteScroll
                    hasMore={isDetailedSearch}
                    dataLength={companiesCollection?.companies?.length ?? 0}
                    next={fetchMoreCompanies}
                    loader={false && <SearchCompanySkeletonBlock sliceFlag={!isDetailedSearch} />}
                    className={classNames(
                      'o-x-hidden  M-Companies spacer',
                      { detailPage: isDetailedSearch },
                    )}
                  >
                    <CompaniesSection
                      heading={companiesCollection?.title}
                      hideDefaultBackground
                      companiesCollection={companiesToDisplay}
                      loading={!globalSearchLoaded}
                      companyCount={companiesCollection.companies}
                      count={companiesCollection.count}
                      query={query?.replace(/&/g, '%26')}
                      listView={isListView}
                      inGlobalSearch
                      showLoaderForLessResults={showInlineLoaderForCompanies}
                      {...(showInlineLoaderForCompanies
                        // eslint-disable-next-line max-len
                        && { numberOfLoaderForLessResults: 10 - (companiesToDisplay?.length ?? 0) })}
                      setCompanyTop={setTopCoordinates}
                    />
                  </InfiniteScroll>
                ) : <> </>}

                {isBuyerGroupsSectionVisible && isListView ? (
                  <InfiniteScroll
                    hasMore={isDetailedSearch}
                    dataLength={buyerGroupsCollection?.groups?.length ?? 0}
                    next={fetchMoreBuyerGroups}
                    loader={false && (
                      <SearchBuyerGroupSkeletonBlock
                        sliceFlag={!isDetailedSearch}
                      />
                    )}
                    className={classNames(
                      'o-x-hidden o-y-hidden M-Buyer spacer',
                      { detailPage: isDetailedSearch },
                    )}
                  >
                    <BuyerGroupsSectionListView
                      heading={buyerGroupsCollection?.title}
                      buyerGroupsCollection={buyerGroupsToDisplayListView}
                      loading={!globalSearchLoaded}
                      buyerGroupCount={buyerGroupsCollection.groups}
                      count={buyerGroupsCollection.count}
                      inGlobalSearch
                      query={query?.replace(/&/g, '%26')}
                    />
                  </InfiniteScroll>
                ) : (<> </>)}

                {isBuyerGroupsSectionVisible && !isListView ? (
                  <InfiniteScroll
                    hasMore={isDetailedSearch}
                    dataLength={buyerGroupsCollection?.groups?.length ?? 0}
                    next={fetchMoreBuyerGroups}
                    loader={false && (
                      <SearchBuyerGroupSkeletonBlock
                        sliceFlag={!isDetailedSearch}
                      />
                    )}
                    className={classNames(
                      'o-x-hidden o-y-hidden M-Buyer spacer',
                      { detailPage: isDetailedSearch },
                    )}
                  >
                    <BuyerGroupsSection
                      heading={buyerGroupsCollection?.title}
                      buyerGroupsCollection={buyerGroupsToDisplay}
                      loading={!globalSearchLoaded}
                      buyerGroupCount={buyerGroupsCollection.groups}
                      count={buyerGroupsCollection.count}
                      query={query?.replace(/&/g, '%26')}
                      inGlobalSearch
                      showLoaderForLessResults={showInlineLoaderForBuyerGroups}
                      {...(showInlineLoaderForBuyerGroups && {
                        numberOfLoaderForLessResults:
                          8 - (buyerGroupsToDisplay?.length ?? 0),
                      })}
                      setGroupTop={setTopCoordinates}
                    />

                  </InfiniteScroll>
                ) : (<> </>
                )}
                {isDocumethubSectionVisible && isListView ? (
                  <InfiniteScroll
                    hasMore={isDetailedSearch}
                    dataLength={documentCollection?.documents?.length ?? 0}
                    next={fetMoreDocuments}
                    loader={false}
                    className={classNames(
                      'o-x-hidden o-y-hidden',
                    )}
                  >
                    <DocumentHubListView
                      heading={documentCollection?.title}
                      count={documentCollection?.count}
                      loading={!globalSearchLoaded}
                      entitiesCount={documentCollection.documents}
                      entitiesToDisplay={documentsToDisplayListView}
                      inGlobalSearch
                      searchQuery={query?.replace(/&/g, '%26')}
                    />
                  </InfiniteScroll>
                ) : null}
                {isDocumethubSectionVisible && !isListView
                  ? (
                    <InfiniteScroll
                      hasMore={isDetailedSearch}
                      dataLength={documentCollection?.documents?.length ?? 0}
                      next={fetMoreDocuments}
                      loader={false}
                    >
                      <DocumentHub
                        heading={documentCollection?.title}
                        count={documentCollection?.count}
                        documentsCount={documentCollection?.documents}
                        inGlobalSearch
                        documentsToDisplay={documentsToDisplay}
                        globalSearchloading={!isDetailedSearch && loading}
                        searchQuery={query?.replace(/&/g, '%26')}
                      />
                    </InfiniteScroll>
                  ) : null}
              </>
            )
          }
          {
            isIndustriesSectionVisible && isListView ? (
              <InfiniteScroll
                hasMore={isDetailedSearch}
                dataLength={industriesCollection?.industries?.length ?? 0}
                next={fetchMoreIndustries}
                loader={false && <SearchIndustrySkeletonBlock sliceFlag={!isDetailedSearch} />}
                className={classNames('o-x-hidden M-Industries spacer', { detailPage: isDetailedSearch })}
              >
                <IndustriesSectionListView
                  heading={industriesCollection?.title}
                  industriesCollection={industriesToDisplayListView}
                  loading={!globalSearchLoaded}
                  industryCount={industriesCollection.industries}
                  count={industriesCollection.count}
                  query={query?.replace(/&/g, '%26')}
                  showUnfollow
                  inGlobalSearch
                />
              </InfiniteScroll>
            ) : (<> </>)

          }
          {
            isIndustriesSectionVisible && !hideIndustries && !isListView ? (
              <InfiniteScroll
                hasMore={isDetailedSearch}
                dataLength={industriesCollection?.industries?.length ?? 0}
                next={fetchMoreIndustries}
                loader={false && <SearchIndustrySkeletonBlock sliceFlag={!isDetailedSearch} />}
                className={classNames('o-x-hidden M-Industries spacer', { detailPage: isDetailedSearch })}
              >
                <IndustriesSection
                  heading={industriesCollection?.title}
                  hideDefaultBackground
                  query={query?.replace(/&/g, '%26')}
                  industriesCollection={industriesToDisplay}
                  loading={!isDetailedSearch && loading}
                  industryCount={industriesCollection.industries}
                  count={industriesCollection.count}
                  showLoaderForLessResults={showInlineLoaderForIndustries}
                  {...(showInlineLoaderForIndustries
                    && { numberOfLoaderForLessResults: 10 - (industriesToDisplay?.length ?? 0) })}
                  showUnfollow
                  setIndustryTop={setTopCoordinates}
                  inGlobalSearch
                />
              </InfiniteScroll>
            ) : <> </>
          }
          {
            isArticlesSectionVisible && isListView ? (
              <InfiniteScroll
                hasMore={isDetailedSearch}
                dataLength={articlesCollection?.articles?.length ?? 0}
                next={fetchMoreArticles}
                loader={false && <SocialCardSkeleton />}
                className={classNames(
                  'o-x-hidden o-y-hidden M-Articles',
                  {
                    spacer:
                      articlesToDisplay && articlesToDisplay?.length < slicerArticleNumber / 2,
                  },
                )}
              >
                <ArticlesSectionListView
                  heading={articlesCollection.title}
                  articlesCollection={articlesToDisplayListView}
                  loading={!globalSearchLoaded}
                  articleCount={articlesCollection.articles}
                  count={articlesCollection.count}
                  inGlobalSearch
                  query={query?.replace(/&/g, '%26')}
                />
              </InfiniteScroll>
            ) : (<> </>)
          }
          {
            isArticlesSectionVisible && !hideArticles && !isListView ? (
              <InfiniteScroll
                hasMore={isDetailedSearch}
                dataLength={articlesCollection?.articles?.length ?? 0}
                next={fetchMoreArticles}
                loader={false && <SocialCardSkeleton />}
                className={classNames(
                  'o-x-hidden o-y-hidden M-Articles',
                  {
                    spacer:
                      articlesToDisplay && articlesToDisplay?.length < slicerArticleNumber / 2,
                  },
                )}
              >
                <ArticlesSection
                  heading={articlesCollection.title}
                  articlesCollection={articlesToDisplay}
                  loading={!isDetailedSearch && loading}
                  query={query?.replace(/&/g, '%26')}
                  articleCount={articlesCollection.articles}
                  count={articlesCollection.count}
                  setArticleTop={setTopCoordinates}
                  inGlobalSearch
                />
              </InfiniteScroll>
            ) : <> </>
          }
          {((!onboardingSearchFlag && isAllDataEmpty()) || isExtendedDataEmpty()) && globalSearchLoaded ? <SearchNoResultFoundWidget marginTop="250px" /> : null}
          {
            onboardingSearchFlag
              && isEmptyDataForOnBoarding() ? <SearchNoResultFoundWidget marginTop="100px" /> : null
          }

        </div>

      </div>
      {showGlobalGilroy
        ? (
          <Gilroy gilroyStates={gilroyStates} gilroyActions={gilroyActions} />
        ) : null}
    </Wrapper>
  );
};

Search.defaultProps = defaultProps;
export default Search;
